var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.salesOrders,
          loading: _vm.isLoading,
          "sort-by": "salesOrder",
          "sort-desc": "",
        },
        scopedSlots: _vm._u([
          {
            key: "item.validation",
            fn: function ({ item }) {
              return [
                _vm.isValid(item)
                  ? _c("v-icon", { attrs: { color: "green" } }, [
                      _vm._v(" " + _vm._s(_vm.mdiCheckCircle) + " "),
                    ])
                  : _c("v-icon", { attrs: { color: "error" } }, [
                      _vm._v(" " + _vm._s(_vm.mdiAlertCircle) + " "),
                    ]),
              ]
            },
          },
          {
            key: "item.orderDate",
            fn: function ({ item }) {
              return [
                _vm._v(" " + _vm._s(_vm.formatDate(item.orderDate)) + " "),
              ]
            },
          },
          {
            key: "item.deliveryDate",
            fn: function ({ item }) {
              return [
                _vm._v(" " + _vm._s(_vm.formatDate(item.deliveryDate)) + " "),
              ]
            },
          },
          {
            key: "item.printCount",
            fn: function ({ item }) {
              return [_vm._v(" " + _vm._s(item.printCount + 1) + " ")]
            },
          },
          {
            key: "item.orderTotalIncVat",
            fn: function ({ item }) {
              return [
                item.orderTotalIncVat
                  ? _c("span", [
                      _vm._v(
                        " R " +
                          _vm._s(_vm.formatCurrency(item.orderTotalIncVat)) +
                          " "
                      ),
                    ])
                  : _c("span", [_vm._v(" - ")]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }